import React from 'react';
import { styled } from '@mui/material/styles';
import { Box, Typography, Button } from '@mui/material';

const CardContainer = styled(Box)(({ theme, bgcolor }) => ({
  backgroundColor: bgcolor || '#FFD6D6',
  borderRadius: '16px',
  padding: '16px 20px',
  width: '100%',
  height: '130px',
  display: 'flex',
  flexDirection: 'column',
  position: 'relative',
  boxShadow: '0 4px 12px rgba(0, 0, 0, 0.03)',
  transition: 'transform 0.2s ease, box-shadow 0.2s ease',
  boxSizing: 'border-box',
  '&:hover': {
    transform: 'translateY(-2px)',
    boxShadow: '0 6px 16px rgba(0, 0, 0, 0.05)',
  },
  [theme.breakpoints.down('sm')]: {
    height: '110px',
    padding: '14px 18px',
  },
}));

const CardTitle = styled(Typography)({
  fontSize: '14px',
  fontWeight: 700,
  color: '#4A5568',
  marginBottom: '2px',
  fontFamily: "'Poppins', 'Inter', sans-serif",
});

const ScoreText = styled(Typography)({
  fontSize: '36px',
  fontWeight: 800,
  color: '#1A202C',
  marginTop: 'auto',
  lineHeight: 1.1,
  fontFamily: "'Poppins', 'Inter', sans-serif",
});

const ChangeButton = styled(Button)({
  position: 'absolute',
  top: '16px',
  right: '16px',
  backgroundColor: '#FFFFFF',
  color: '#4A5568',
  borderRadius: '20px',
  padding: '2px 10px',
  fontSize: '10px',
  fontWeight: 700,
  textTransform: 'none',
  minWidth: 'auto',
  boxShadow: '0 1px 2px rgba(0, 0, 0, 0.08)',
  '&:hover': {
    backgroundColor: '#F7FAFC',
    boxShadow: '0 2px 4px rgba(0, 0, 0, 0.12)',
  },
});

const IconContainer = styled(Box)({
  position: 'absolute',
  right: '20px',
  bottom: '16px',
  width: '32px',
  height: '32px',
  display: 'flex',
  justifyContent: 'center',
  alignItems: 'center',
  opacity: 0.5,
});

const ScoreCard = ({ title, score, icon, bgcolor, showChangeButton = false, onChangeClick }) => {
  return (
    <CardContainer bgcolor={bgcolor}>
      <CardTitle>{title}</CardTitle>
      {showChangeButton && (
        <ChangeButton onClick={onChangeClick}>Change</ChangeButton>
      )}
      <ScoreText>{score}</ScoreText>
      <IconContainer>
        {icon}
      </IconContainer>
    </CardContainer>
  );
};

export default ScoreCard; 